import { StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  button: {
    justifyContent: 'center',
    display: 'flex',
    flex: 1,
    minHeight: 48,
    borderRadius: 100,
    borderColor: 'transparent',
    borderWidth: 3,
    backgroundColor: brand.main.water,
    ...getBoxShadow({
      offsetX: 2,
      offsetY: 2,
      blurRadius: 4,
      color: brand.main.variations['lighterWater-2'],
    }),
  },
  buttonInner: {
    height: '100%',
    width: '100%',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  buttonHover: {
    backgroundColor: brand.main.variations['darkerWater-1'],
    ...getBoxShadow({
      offsetX: 2,
      offsetY: 2,
      blurRadius: 4,
      spreadRadius: 2,
      color: brand.main.variations['lighterWater-2'],
    }),
  },
  buttonPressed: {
    backgroundColor: brand.main.variations['darkerWater-2'],
    ...getBoxShadow({
      offsetX: 2,
      offsetY: 2,
      blurRadius: 4,
      spreadRadius: 2,
      color: brand.main.variations['lighterWater-2'],
    }),
  },
  buttonFocus: {
    backgroundColor: brand.main.variations['darkerWater-1'],
    borderColor: brand.main.variations['lighterWater-2'],
    ...getBoxShadow({
      offsetX: 5,
      offsetY: 5,
      blurRadius: 3.1,
      spreadRadius: 2,
      color: brand.main.variations['lighterWater-2'],
    }),
  },
  buttonDisabled: {
    cursor: 'not-allowed',
    backgroundColor: neutrals.neutralGrays.dust,
    ...getBoxShadow('none'),
  },
  text: { fontSize: 16, fontWeight: 700, lineHeight: 22, textAlign: 'center', color: neutrals.white },
  textHover: { color: neutrals.white },
  textPressed: { color: neutrals.white },
  textFocus: { color: neutrals.white },
  textDisabled: {
    color: neutrals.neutralGrays.ash,
  },
});
